module.exports = __webpack_public_path__ + "img/lshebeiBg.79faa9e3.png";